import React, {useState, useEffect, useCallback} from 'react';
import {lstorage} from 'utils/lstorage.js';
import {deleteList} from 'decentralized/lists/ExploreLists.js';

export const useLists = (props, sequencerEngine) => {
    const [creatingNewList, setCreatingNewList] = useState(false);
    const [lists, setLists] = useState([]);

    const onListChanged = useCallback((list, shouldDelete=false) => {
        if (list === undefined) {
            setCreatingNewList(false);
            return;
        }
        // see if list exists
        // if not add it
        // otherwise replace it
        let unsavedLists = lstorage.getItem("unsavedLists");
        if (unsavedLists) {
            unsavedLists = JSON.parse(unsavedLists);
        } 

        if (list.hash === undefined) {
            if (shouldDelete) {
                // delete it from the local storage
                let filtered =  
                    props.allSequences.filter(
                        x => x.id !== list.id);
                props.setAllSequences(filtered);
                if (unsavedLists) {
                    unsavedLists = unsavedLists.filter(
                        x => x.name !== list.name);
                    lstorage.setItem("unsavedLists", JSON.stringify(unsavedLists));
                    props.setExploreUnpublished(unsavedLists);
                }
            } else {
                // replace it from the local storage
                props.setAllSequences([
                    {
                        ... list,
                        type: 'LIST'
                    },
                    ... props.allSequences,
            ]);
            }
        } else {
            if (shouldDelete) {
                // it does have a hash, so we must run a deleteList transactiono
                // and remove it from the allSequnces
                deleteList(list.newContent);
                let filtered =  
                    props.allSequences.filter(
                        x => x.hash !== list.hash);
                props.setAllSequences(filtered);
            }
        }
        setCreatingNewList(false);
    }, [setCreatingNewList, sequencerEngine, props.allSequences]);

    const onClickList = useCallback((list) => {
        if (lists.indexOf(list) > -1) {
            let _lists = [... lists];
            _lists.splice(lists.indexOf(list), 1);
            setLists(_lists);
        }  else {
            setLists([... lists, list]);
        }
    }, [setLists, lists]);


    return {lists, onListChanged, onClickList, creatingNewList, setCreatingNewList};
};
